import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehiclePowersportPurchaseSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <g>
            <path
              className={css(styles.actionAccent)}
              d="M63.391,34.32a1.6,1.6,0,1,0-1.6,1.6A1.6,1.6,0,0,0,63.391,34.32Zm-1.733-7.21H83.665a1.336,1.336,0,0,1,1.355,1.315V39.414a1.335,1.335,0,0,1-1.355,1.314H61.658a1.377,1.377,0,0,1-.965-.39l-5.589-5.5A1.287,1.287,0,0,1,55.1,33l5.589-5.5A1.378,1.378,0,0,1,61.658,27.11Zm11.16,9.412c-.591-.158-.986-.539-.986-.926a.6.6,0,0,0-1.2,0,2.379,2.379,0,0,0,2.188,2.154v.361a.6.6,0,1,0,1.2,0v-.36A2.373,2.373,0,0,0,76.208,35.6a2.373,2.373,0,0,0-2.188-2.155V31.46c.593.157.986.537.986.928a.6.6,0,1,0,1.2,0,2.373,2.373,0,0,0-2.188-2.155v-.506a.6.6,0,1,0-1.2,0v.506a2.373,2.373,0,0,0-2.188,2.155,2.373,2.373,0,0,0,2.188,2.154Zm1.2,0V34.668c.593.158.986.538.986.928S74.613,36.366,74.02,36.524Zm-1.2-5.064v1.855c-.593-.158-.986-.537-.986-.927S72.225,31.617,72.818,31.46Z"
            />
            <path
              className={css(styles.grey)}
              d="M61.227,34.875c-.331.052-.7.121-1.1.212a16.134,16.134,0,0,0-3.34,1.132c-1.286.609-5.037,4.341-5.388,5.806-.621-.025-.053-1.324-.762-1.289a22.811,22.811,0,0,1,5.571-5.745,11.223,11.223,0,0,1,3.621-1.228c.431-.1.832-.174,1.192-.23.22-.034.38-.054.471-.064a.679.679,0,0,1,.137,1.351C61.56,34.827,61.423,34.845,61.227,34.875Z"
            />
          </g>
          <path
            className={css(styles.actionAccent)}
            d="M67.968,54.837a8.558,8.558,0,1,0,8.557,8.557A8.558,8.558,0,0,0,67.968,54.837ZM67.95,66.525a3.261,3.261,0,1,1,3.261-3.261A3.261,3.261,0,0,1,67.95,66.525Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M24.788,55.775a8.558,8.558,0,1,0,8.558,8.557A8.557,8.557,0,0,0,24.788,55.775Zm-.017,11.688a3.261,3.261,0,1,1,3.26-3.261A3.261,3.261,0,0,1,24.771,67.463Z"
          />
          <path
            className={css(styles.grey)}
            d="M75.411,55.036a11.907,11.907,0,0,0-10.28-2.419,12.1,12.1,0,0,0-5.965,3.016L51,47.331l.436-1.666-2.194-2.2a13.594,13.594,0,0,0-9.612-3.981H37.172l-10.35,8.938c5.964,5.78,7.412,10.957,7.722,13.73a8.919,8.919,0,0,1,.482,2.212c5.364.921,11.536,2.637,15.437-1.077l1.184-1.126a4.193,4.193,0,0,1,4.643-.773l3.048,1.251.592-1.737c.091-.039.147-.066.147-.066,0-.022.01-.045.014-.067a9.852,9.852,0,0,1,9.191-5.651c6.919,0,9.383,6.337,9.383,6.337C79.112,60.484,77.788,57.105,75.411,55.036Z"
          />
          <path
            className={css(styles.action)}
            d="M49.766,46.724c-.609-6.857-2.41-9.237-2.41-9.237C28.777,33.052,24.593,48.974,24.593,48.974l-2,5.305c-.095.02-.2.028-.289.052-5.287,1-7.773,4.988-7.261,6.293.616,1.567,2.807.538,2.807.538,0-.018.009-.037.012-.056a8.665,8.665,0,0,1,8.1-4.694,9.6,9.6,0,0,1,8.488,5.408c.286-.589-.376-2.309-1.56-3.865,2.354-7.18,12.369-13.344,12.369-13.344l5.972,3.772C51.956,47.989,49.839,47.545,49.766,46.724Z"
          />
          <path
            className={css(styles.action)}
            d="M63.16,44.741c3.248-.45,7.162-.567,8.413,1.162,0,0,1.277,3.88-7.186,7.058a13.942,13.942,0,0,0-2.794,3.348c-1.606,2.389-6.261-5.444-11.61-6.71a11.57,11.57,0,0,1-4.712-2.21c-1.35-1.108-2.177-2.392-.083-3.093s5.385-.354,8.152.168A30.4,30.4,0,0,0,63.16,44.741Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M47.391,37.505s-8.7,3.981-10.791,8.87S31.217,58.02,31.217,58.02l.937.762a23.479,23.479,0,0,1,1.739,2.032l.656,1.361,5.823-12.308,9.227-.3,1.369.381,1.225-2.63s1.055-2.776-1.763-6.81C48.4,37.61,47.391,37.505,47.391,37.505Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M54.133,29.4H45.524a1.243,1.243,0,0,0-.966.467A6.936,6.936,0,0,0,40.845,31.8l-2.366,2.366,1.252,1.252L42.1,33.055a5.2,5.2,0,0,1,2.511-1.391,1.246,1.246,0,0,0,.916.407h8.609a.619.619,0,0,0,.617-.618V30.017A.618.618,0,0,0,54.133,29.4Z"
          />
          <path
            className={css(styles.action)}
            d="M30.832,32.539a4.6,4.6,0,0,0-1.241-.05,3.335,3.335,0,0,1,2.221,4.122,3.365,3.365,0,0,1-3.527,2.863,4.631,4.631,0,0,0,.81.235A4.155,4.155,0,0,0,34,36.9,3.692,3.692,0,0,0,30.832,32.539Z"
          />
          <path
            className={css(styles.grey)}
            d="M38.8,33.053H32.2a3.5,3.5,0,0,1,1.772,3.828A4.156,4.156,0,0,1,29.07,39.7a4.656,4.656,0,0,1-.81-.235c-.066-.009-.132-.005-.2-.019a2.853,2.853,0,0,1-1.94-1.6v6.838a2.592,2.592,0,0,0,4.321,1.931L40.53,37.576A2.592,2.592,0,0,0,38.8,33.053Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M26.344,33.555a3.217,3.217,0,0,1,1.47-1.035l-.879-.879a7.023,7.023,0,0,0-1.463-1.115,1.253,1.253,0,0,0-1.232-1.064H16.811a.62.62,0,0,0-.618.618v1.437a.619.619,0,0,0,.618.617H24.24a1.213,1.213,0,0,0,.368-.062,5.265,5.265,0,0,1,1.075.821Z"
          />
        </g>
      </svg>
    );
  }
}
